import { useState } from "react";
import ArrowImg from "./Img/arrow_sprite.svg"
import "./SearchBarSelectStatus.scss";
import { OptionsStatusList, ActiveOptionsStatus, getActiveOptionsStatus } from './helpers';
import { WidthFormControl } from "../../../../models/models";
import ImageSprite from "../../ImageSprite/ImageSprite";


export type onChangeStateHandler = {
    id: number;
    state: boolean;
}

export type ActiveOptionsStatusHandler = (activeOptionsStatus: ActiveOptionsStatus) => void;

interface Props {
    label?: string;
    options: OptionsStatusList | undefined;
    activeOptionsStatusHandler: ActiveOptionsStatusHandler
    name: string;
    widthFormControl: WidthFormControl
}

const SearchBarSearchBarSelectStatus = ({
    options = [],
    activeOptionsStatusHandler,
    label,
    name,
    widthFormControl
}: Props) => {
    const [optionList, setOptionsList] = useState<OptionsStatusList>(options);
    const onChangeStateOptionHandler = (
        {
            id,
            state
        }: onChangeStateHandler) => {
        const updatedListOptions: OptionsStatusList =
            optionList.map((option) =>
                id === option.id ? { ...option, checked: !state } : option
            );

        setOptionsList(updatedListOptions);
        const activeOptionsStatus = getActiveOptionsStatus(updatedListOptions);
        activeOptionsStatusHandler(activeOptionsStatus);
    };

    return (
        <div className="form_control" style={{ maxWidth: widthFormControl }}>
            <label className="label">{label}</label>
            <div className="select_status">
                <div className="select_status__caption unSelectable">
                    <span className="select_status__caption_name">{name}</span>
                    <div className="select_status__caption_img">
                        <ImageSprite iconSprite={`${ArrowImg}#arrow`} />
                    </div>
                </div>

                <div className="select_status__popup">
                    <div className="select_status__popup_container">
                        {optionList.map((option, id) => (
                            <li
                                className={`select_status__option ${option.checked ? "selected" : ""}`}
                                key={id}
                                onClick={() =>
                                    onChangeStateOptionHandler({ id: option.id, state: option.checked }) // TODO: save in to array and send to the server
                                }
                            >
                                <div className="select_status__option_content">
                                    <div className="select_status__option_circle">
                                        <div className={`status_background ${option.color}`}></div>
                                    </div>
                                    <div className="select_status__option_label">
                                        {option.name}
                                    </div>
                                    <input
                                        id={String(id)}
                                        className="select_status__option_checkbox"
                                        checked={option.checked}
                                        name="optionState"
                                        type="checkbox"
                                        value={String(option.checked)}
                                        onChange={() => { }}
                                    />
                                </div>
                            </li>
                        ))}
                    </div>
                </div>
            </div>
        </div >
    );
};

export default SearchBarSearchBarSelectStatus;
